import { ReactNode } from 'react';
import { withStyles, Icon, MaterialSymbol } from 'vopay';
import { TransactionStatusVariant } from './normalizeStatus';
import styles from './TransactionStatus.module.scss';

// Feature-local to TransactionHistory (ID-13367): the status pill, deps rewritten to vopay only. Not exported
// from the package — internal to this feature (shared-owned rendering, so an iframe host needs no injected
// render function). Promote to component-library if a third consumer appears.
//
// `status` is the normalized variant from `normalizeStatus` (one icon + one color each), so the maps below are
// exhaustive and need no runtime fallback.
const statusIcons: Record<TransactionStatusVariant, ReactNode> = {
  pending: <Icon icon="transactionPending" height="18px" width="18px" color="none" />,
  success: <MaterialSymbol icon="check_circle" size="18px" color="#008107" />,
  failed: <MaterialSymbol icon="cancel" size="18px" color="#e8160b" />,
  reversed: <MaterialSymbol icon="undo" size="18px" color="#e8160b" />,
  blocked: <MaterialSymbol icon="block" size="18px" color="#2D2D2DBF" />,
  partiallyPaid: <Icon icon="partiallyPaid" height="18px" width="18px" color="none" />,
  upcoming: <MaterialSymbol icon="calendar_today" size="18px" />,
};

const statusColors: Record<TransactionStatusVariant, string> = {
  pending: 'gray',
  success: 'green',
  failed: 'red',
  reversed: 'red',
  blocked: 'gray',
  partiallyPaid: 'gray',
  upcoming: 'blue',
};

type TransactionStatusProps = {
  status: TransactionStatusVariant;
  label: string;
};

const classes = withStyles(styles);

export default function TransactionStatus({ status, label }: TransactionStatusProps) {
  return (
    <div className={classes('transactionStatus', statusColors[status])}>
      {statusIcons[status]}
      <div className={classes('statusLabel')}>{label}</div>
    </div>
  );
}
